import React, { useEffect, useContext, useState } from 'react';

import { useLocation } from 'react-router-dom';
import { MunicipalityStore } from 'ewp-common';

import FormDataStore from '../../../stores/formDataStore';

export interface PropsFromBaseForm {
  formData: any;
  fetchFormData: () => Promise<any>;
  formDataResponse: any;
  activeRoute: number;
  setRoute: (route: number) => void;
}

const withBaseForm = WrappedComponent => (props) => {
  const { search = '' } = useLocation();
  const [activeRoute, setRoute] = useState(1);
  const searchParams = new URLSearchParams(search);
  const documentId = searchParams.get('reference');
  const status = searchParams.get('status');

  const {
    fetchMunicipalityDetails,
  } = useContext(MunicipalityStore.MunicipalityContext);

  const {
    state: formData,
    fetchFormData,
  } = useContext(FormDataStore.FormDataContext);

  function checkForPayment(paymentStatus) {
    switch (paymentStatus ?? status) {
      case 'cancel': {
        setRoute(3);
        break;
      }

      case 'confirmed': {
        setRoute(4);
        break;
      }

      default:
        setRoute(3);
    }
  }

  async function fetchInitialDetails() {
    const result = await fetchFormData(documentId);
    if (result) {
      const { municipalityId, paymentStatus } = result;
      await fetchMunicipalityDetails(municipalityId);
      checkForPayment(paymentStatus);
    }
  }

  useEffect(() => {
    if (documentId) {
      fetchInitialDetails();
    }
  }, []);
  return (
    <WrappedComponent
      {...props}
      formData={formData}
      fetchFormData={fetchFormData}
      activeRoute={activeRoute}
      setRoute={setRoute}
    />
  );
};

export default withBaseForm;
